document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.getElementById('StickyAddToCart');
  const stickyBtn = document.getElementById('StickyAddToCartButton');
  const productForm = document.querySelector('.product-form form');
  
  // Find the main submit button inside the product form
  const mainSubmitBtn = productForm ? productForm.querySelector('[name="add"]') : null;

  if (!stickyBar || !mainSubmitBtn) return;

  // Setup intersection observer on the main add to cart button
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // If the main button is not intersecting (scrolled out of view) and we scrolled down
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    });
  }, observerOptions);

  observer.observe(mainSubmitBtn);

  // When sticky button is clicked, trigger click on main button
  stickyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (mainSubmitBtn) {
      mainSubmitBtn.click();
    }
  });
  
  // Sync button text/state
  const originalTextObserver = new MutationObserver(() => {
    if (stickyBtn.querySelector('span') && mainSubmitBtn.querySelector('span')) {
      stickyBtn.querySelector('span').textContent = mainSubmitBtn.querySelector('span').textContent;
    }
    if (mainSubmitBtn.disabled) {
      stickyBtn.setAttribute('disabled', 'disabled');
      stickyBtn.classList.add('disabled');
    } else {
      stickyBtn.removeAttribute('disabled');
      stickyBtn.classList.remove('disabled');
    }
  });
  
  originalTextObserver.observe(mainSubmitBtn, { attributes: true, childList: true, subtree: true });
});
